import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { collaborationSevice } from '../../_services/Analyze/collaboration.service';

export const collaborationAction = {
    collaborationDataAction
}

//OrgAdmin ORG TEAM starts
function collaborationDataAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        collaborationSevice.getCollaborationData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                    callBack != undefined ? callBack(error) : null
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_COLLOBORATION_DATA } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_COLLOBORATION_DATA, res } }
    function failure(error) { return { type: AnalyzeConstants.ERRO_COLLOBORATION_DATA, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/collaboration.action.js